/* eslint-disable no-console */
const productOptions = () => {
  const productOptionsDiv = document.querySelector('.product-options-grid');
  if (!productOptionsDiv) {
    return;
  }

  const optionSelect = productOptionsDiv.querySelector('#ProductOptions');
  const optionList = optionSelect.querySelectorAll('option');
  let resizeTimer = null;

  const showActiveOption = (id) => {
    // Loop through all options in dropdown
    for (let i = 0; i < optionList.length; i++) { /* eslint-disable-line no-plusplus */
      const option = optionList[i];
      const optionDiv = document.getElementById(option.value);
      if (option.value === id && optionDiv !== null) {
        optionDiv.classList.remove('hidden');
      } else if (option.value !== id && optionDiv !== null) {
        optionDiv.classList.add('hidden');
      }
    }
  };

  const showAllOptions = () => {
    for (let i = 0; i < optionList.length; i++) { /* eslint-disable-line no-plusplus */
      const option = optionList[i];
      const optionDiv = document.getElementById(option.value);
      if (optionDiv !== null) {
        optionDiv.classList.remove('hidden');
      }
    }
  };

  const onWindowResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth > 991) {
        showAllOptions();
      } else {
        showActiveOption(optionSelect.value);
      }
    }, 100);
  };

  optionSelect.addEventListener('change', (event) => {
    showActiveOption(event.target.value);
    window.dispatchEvent(window.resetGlideEvent);
  });
  window.addEventListener('resize', onWindowResize);
  onWindowResize();
};

export default productOptions;
/* eslint-enable no-console */
